import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './ThreadStack';
import { getThreadState } from '../../selectors';
import { pushCommentsModal } from '../../../Modals/redux/actionCreators';
import { threadUpdated } from '../../actionCreators';

export type StateProps = Pick<
  Props,
  'streamId' | 'items' | 'canPostComment' | 'maxDepth'
>;
export type DispatchProps = Pick<
  Props,
  'onOpenCommentModal' | 'onThreadUpdated'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (
  state,
  { commentableItemId, commentableTypeId, parentId }
) => {
  const { streamId, canPostComment, items, maxDepth, lastInsertedCommentId } =
    getThreadState(state, commentableTypeId, commentableItemId, parentId);

  return {
    streamId,
    canPostComment,
    items,
    maxDepth,
    lastInsertedCommentId,
  };
};
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onOpenCommentModal: pushCommentsModal,
  onThreadUpdated: threadUpdated,
};

export default connect(mapStateToProps, mapDispatchToProps);
